
const defaultGapProfile = {

    filter: {
       benefitYear: 0,
       hiosId: "All",
       market: "All",
       defaultFilter: true,
       submitted: false
    },

    pagination: {
        pageCount: 0,
        pageNumber:1,
        pageSize: 10,
        sortKey: 'PlanID',
        sortDirection: 'ASC'
    }
   
}

const defaultState = {
    type: "SET_GAP_PROFILE",
    gapProfile: {...defaultGapProfile}
}

const gapProfileStates = (state = [{...defaultState}], action) => {
    
    switch (action.type) {
       case "SET_GAP_PROFILE":             
           if (state.find(x => x.type === action.type)) {
               return state.map(gapProfileStates =>
                   (gapProfileStates.type === action.type)
                   ? { ...gapProfileStates, gapProfile: action.gapProfile }
                   : gapProfileStates
               );
           }
           else {
               return [
                   ...state,
                   {
                       type: action.type,
                       gapProfile: action.gapProfile
                   }
               ];
           }
       
       case "RESET_GAP_PROFILE":
           if (state.find(x => x.type === action.type)) {
               return state.map(gapProfileStates => 
                   (gapProfileStates.type === action.type)
                   ? { ...gapProfileStates, gapProfile: defaultGapProfile }
                   : gapProfileStates
               );
           }
           else {
               return [
                   ...state,
                   {
                       type: "SET_GAP_PROFILE",
                       gapProfile: defaultGapProfile
                   }
               ];
           }

           
       default:
            return state;
    }
};

export default gapProfileStates;
